/* 个人、企业信息接口 */

import axios from 'axios';

export default {
  getPersonalInfo (params) {
    // 个人信息，读取
    return axios.get('/crmform/customer/crmCustomer/getPersonInformation.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId
      }
    });
  },

  getPersonalInitData (params) { // 个人信息初始化
    return axios.get('/crmform/customer/crmCustomer/getPersonInformationDetail.ht',
      {
        headers: {
          tokenId: params.token
        },
        params: {
          customerId: params.customerId
        }
      }
    );
  },

  savePersonalInfo (params) { // 个人信息-实名认证，保存
    return axios.get(
      '/mobile/crmCustomerPersonInfoController/saveAndUpdatePersonalInfoMd.ht',
      {
        headers: {
          tokenId: params.token
        },
        params: {
          customerId: params.customerId,
          customerName: params.customerName,
          personIdentityCard: params.personIdentityCard
        }
      }
    );
  },

  savePersonalInfoall (params) { // 个人信息-个人信息，保存
    return axios.get(
      '/mobile/crmCustomerPersonInfoController/saveAndUpdatePersonalInfoDetailMd.ht',
      {
        headers: {
          tokenId: params.token
        },
        params: {
          // personSex: params.personSex,
          // personBirthDate: params.personBirthDate,
          personEducation: params.personEducation,
          personCollege: params.personCollege,
          customerArea: params.customerArea,
          personCategory: params.personCategory,
          personCensusAddr: params.personCensusAddr,
          personMarital: params.personMarital,
          personFamily: params.personFamily,
          personExistChild: params.personExistChild,
          personHouse: params.personHouse,
          b: params.b,
          personDwellAddr: params.personDwellAddr,
          personCompanyName: params.personCompanyName, // 工作单位全称
          personCompanyAddr: params.personCompanyAddr,
          personCompanyTime: params.personCompanyTime,
          personCompanyPost: params.personCompanyPost,
          personCompanyPhone: params.personCompanyPhone,
          personCompanyNature: params.personCompanyNature,
          personCompanyLinkman: params.personCompanyLinkman,
          personCompanyLinkmanPhone: params.personCompanyLinkmanPhone,
          personYearIncome: params.personYearIncome,
          personCompanyAge: params.personCompanyAge,
          personSocialSecurityTime: params.personSocialSecurityTime
        }
      }
    );
  },

  getEnterpriseInfo (params) { // 企业信息，读取
    return axios.get(
      '/mobile/crmCustomerCompanyInfoController/getCompanyInfo.ht',
      {
        headers: {
          tokenId: params.token
        },
        params: {
          customerId: params.customerId
        }
      }
    );
  },

  saveEnterpriseInfo (params) { // 企业信息，保存
    return axios.get(
      '/mobile/crmCustomerCompanyInfoController/saveAndUpdateCompanyInfo.ht',
      {
        headers: {
          tokenId: params.token
        },
        params: {
          customerId: params.customerId,
          customerName: params.customerName,
          enterpriseNumber: params.enterpriseNumber,
          enterprisePartnerNumber: params.enterprisePartnerNumber,
          enterpriseRegAddr: params.enterpriseRegAddr,
          enterpriseOfficeAddress: params.enterpriseOfficeAddress,
          enterpriseType: params.enterpriseType,
          enterpriseRegMoney: params.enterpriseRegMoney,
          enterpriseLegalUser: params.enterpriseLegalUser,
          enterpriseLegalIdNo: params.enterpriseLegalIdNo,
          enterpriseLegalUserPhone: params.enterpriseLegalUserPhone,
          enterpriseOrganizingNumber: params.enterpriseOrganizingNumber,
          enterpriseScale: params.enterpriseScale,
          enterpriseNationalNumber: params.enterpriseNationalNumber,
          enterpriseGovernmentNumber: params.enterpriseGovernmentNumber,
          enterpriseRegOrgan: params.enterpriseRegOrgan,
          enterpriseEmployeeNum: params.enterpriseEmployeeNum,
          enterpriseScope: params.enterpriseScope,
          enterpriseFoundExplain: params.enterpriseFoundExplain,
          userType: params.userType,
          registrationType: params.registrationType,
          province: params.province,
          city: params.city,
          enterpriseIndustry: params.enterpriseIndustry
        }
      }
    );
  },

  getByCatKey (params) {
    // 初始化区域数据
    return axios.get('/platform/system/getFromSysGlType/getByCatKeyPC.ht', {
      params: {
        catKey: params.catKey,
        parentId: params.parentId
      }
    });
  },

  getallSelect () {
    // 初始化区域数据
    return axios.get('/platform/system/getFromSysDic/getByNodeKeyPC.ht', {
      params: {
        NodeKeys:
          'SEX,personEducation,personCategory,personMarital,whether,residentialMake,customer_type,documentType'
      }
    });
  },

  getProvinceList () {
    // 获取省份列表
    return axios.get(
      '/zhongdengwang/blZhongdengwangRegister/getProvinceList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }
      }
    );
  },

  getCityList (params) {
    // 获取城市列表
    return axios.get('/zhongdengwang/blZhongdengwangRegister/getCityList.ht', {
      headers: {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      },
      params
    });
  },

  getBelongIndustryList () {
    // 获取所属行业
    return axios.get(
      '/zhongdengwang/blZhongdengwangRegister/getBelongIndustryList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }
      }
    );
  },

  getCorporationscaleList () {
    // 获取企业规模
    return axios.get(
      '/zhongdengwang/blZhongdengwangRegister/getCorporationscaleList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/myInfo.js